module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"details":"Details of the results"},"es":{"details":"Detalles de los resultados"},"fr":{"details":"Détail des résultats"},"it":{"details":"Dettaglio dei risultati"},"pt":{"details":"Detalhe dos resultados"},"pl":{"details":"Szczegóły wyników"}}')
  delete Component.options._Ctor
}
